module.exports = __webpack_public_path__ + "static/media/student15.a46dff26.png";